<ng-container *ngIf="!page || page.error">
   <app-not-found></app-not-found>
</ng-container>


<app-pages *ngIf="page && page.id && !page.error && page.success" [page]="page" ></app-pages>